import React from 'react';
import { Play } from 'lucide-react';

interface VideoPlayerPanelProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  videoUrl?: string | null;
  audioUrl?: string | null;
}

/**
 * Simple video display panel. Owns only the <video> element.
 * All playback controls and the waveform live in the parent WorkspaceInner.
 *
 * The video element is always muted — WaveSurfer manages its own internal audio
 * element (using audioUrl if available, otherwise videoUrl). The video element
 * is synced to WaveSurfer via play/pause/seeking events in useVideoPlayer.
 */
const VideoPlayerPanel: React.FC<VideoPlayerPanelProps> = ({ videoRef, videoUrl, audioUrl }) => {
  return (
    <div className="flex flex-col bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <div className="relative bg-black">
        <video
          ref={videoRef}
          src={videoUrl ?? undefined}
          className={['w-full object-contain', videoUrl ? 'max-h-64' : 'h-0'].join(' ')}
          preload="metadata"
          controls={false}
          muted
        />
        {!videoUrl && (
          <div className="flex items-center justify-center bg-gray-900 h-28">
            <div className="text-center">
              <div className="w-10 h-10 mx-auto mb-1.5 bg-gray-700 rounded-full flex items-center justify-center">
                <Play className="w-4 h-4 text-gray-400" />
              </div>
              <p className="text-xs text-gray-500">{audioUrl ? 'Audio only' : 'No media'}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPlayerPanel;
